var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#D9D9D9",
    fillOpacity: 0.09
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    stroke: "#363636",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 17.9998C29.8125 17.8123 29.5582 17.707 29.2931 17.707C29.0279 17.707 28.7736 17.8123 28.5861 17.9998L24.0001 22.5858L19.4141 17.9998C19.2265 17.8123 18.9722 17.707 18.7071 17.707C18.4419 17.707 18.1876 17.8123 18.0001 17.9998C17.8126 18.1873 17.7073 18.4417 17.7073 18.7068C17.7073 18.972 17.8126 19.2263 18.0001 19.4138L22.5861 23.9998L18.0001 28.5858C17.8126 28.7733 17.7073 29.0277 17.7073 29.2928C17.7073 29.558 17.8126 29.8123 18.0001 29.9998C18.1876 30.1873 18.4419 30.2926 18.7071 30.2926C18.9722 30.2926 19.2265 30.1873 19.4141 29.9998L24.0001 25.4138L28.5861 29.9998C28.7736 30.1873 29.0279 30.2926 29.2931 30.2926C29.5582 30.2926 29.8125 30.1873 30.0001 29.9998C30.1875 29.8123 30.2928 29.558 30.2928 29.2928C30.2928 29.0277 30.1875 28.7733 30.0001 28.5858L25.4141 23.9998L30.0001 19.4138C30.1875 19.2263 30.2928 18.972 30.2928 18.7068C30.2928 18.4417 30.1875 18.1873 30.0001 17.9998Z",
    fill: "#475467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.382f622341ab1e57eb77a186937e8b79.svg";
export { ForwardRef as ReactComponent };